import React from "react";
import * as d3 from "d3";

export interface ILoanPieChartProps {
    height: number;
    width: number;
    paidAmount: number;
    unPaidAmount: number;
    donutThickness?: number;
    donutInset?: number;
}

const HYPOBLUE = "#004170";
const HYPOLBLUE = "#2196F3";
const HYPOGREEN = "#63A51D";

export class LoanPieChart extends React.Component<ILoanPieChartProps, {}> {
    node: SVGSVGElement | null = null;
    rootView: d3.Selection<SVGSVGElement | null, {}, null, undefined>;

    constructor(props: ILoanPieChartProps) {
        super(props);
    }

    componentDidMount() {
        this.drawPieChart();
    }

    componentWillUpdate() {
        this.drawPieChart();
    }

    componentWillReceiveProps() {
        this.drawPieChart();
    }

    drawPieChart = () => {
        this.rootView && this.rootView.selectAll("*").remove();
        this.rootView = d3.select(this.node);

        const data = [
            { name: "paidAmount", value: this.props.paidAmount },
            { name: "unPaidAmount", value: this.props.unPaidAmount },
        ];

        const width = this.props.width;
        const height = this.props.height;
        const thickness = this.props.donutThickness || 10;
        const inset = this.props.donutInset || 10;
        const radius = width <= height ? width / 2 : height / 2;

        let svg = d3
            .select(this.node)
            .data([data])
            .attr("width", width)
            .attr("height", height)
            .append("g")
            .attr("transform", `translate(${radius}, ${radius})`);

        let arcDonut = d3
            .arc()
            .outerRadius(radius - inset)
            .innerRadius(radius - (inset + thickness));

        let arcPie = d3.arc().outerRadius(radius).innerRadius(0);

        let pie = d3
            .pie()
            .value((d: any) => {
                return d.value;
            })
            .sortValues((a, b) => {
                return 0;
            }); //Always start increasing size of donut clockwise.

        let arcs = svg
            .selectAll("g.slice")
            .data(pie as any)
            .enter()
            .append("svg:g")
            .attr("class", "slice");

        arcs.append("svg:path")
            .attr("fill", (d: any, i: number) => {
                return d.data.name === "unPaidAmount" ? HYPOBLUE : "none";
            })
            .attr("d", arcPie as any)
            .attr("stroke", "#FFF")
            .attr("stroke-width", "5px");

        arcs.append("svg:path")
            .attr("fill", (d: any, i: number) => {
                return d.data.name === "unPaidAmount" ? "none" : HYPOGREEN;
            })
            .attr("d", arcDonut as any);

        // arcs.append("svg:text")
        //     .attr("transform", (d: any) => {
        //         d.innerRadius = radius - 10;
        //         d.outerRadius = radius;
        //         return `translate(${arc.centroid(d)})`;
        //     });
    };

    render() {
        return (
            <svg
                className="loan-pie-chart"
                ref={(node) => (this.node = node)}
                width={this.props.width}
                height={this.props.height}
            ></svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/LoanPieChart/LoanPieChart.tsx